/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./project-can-be-closed-action-body').ProjectCanBeClosedActionBody} ProjectCanBeClosedActionBody
 */

/**
 * @typedef {import('./project-can-be-closed-action-response').ProjectCanBeClosedActionResponse} ProjectCanBeClosedActionResponse
 */

/**
 * The path of the ProjectCanBeClosedAction action.
 */
export const projectCanBeClosedActionPath = new SweetPath('/api/project/project/{project_id}/can-be-closed', {
  path: '{param}',
});

/**
 * Creates a contextualized ProjectCanBeClosedAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createProjectCanBeClosedAction(axios) {
  /**
   * The projectCanBeClosedAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<ProjectCanBeClosedActionResponse>}
   */
  function projectCanBeClosedAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = projectCanBeClosedActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return projectCanBeClosedAction;
}
